import { AISchedule, AIScheduleInvite } from '../../@types/ai-schedules';
import { addListener } from '../common';

export const onAiScheduleUpdate = addListener<AISchedule>('/ai-call/update');
export const onAiScheduleInvite =
  addListener<AIScheduleInvite>('/ai-call/invited');
export const onAiScheduleAccepted =
  addListener<AIScheduleInvite>('/ai-call/accepted');
export const onAiScheduleNotAnswered = addListener<AIScheduleInvite>(
  '/ai-call/not-answered',
);
export const onAiScheduleDeclined =
  addListener<AIScheduleInvite>('/ai-call/declined');
